import React from 'react';
import { UserPlus, Languages, Rocket } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      icon: UserPlus,
      number: '01',
      title: 'Create a Child Profile',
      description: 'Set up a learner with their name, avatar, age, and learning preferences.',
      color: '#FF7F30',
    },
    {
      icon: Languages,
      number: '02',
      title: 'Choose Language & Voice',
      description: 'Select the target language and preview narrator voices to find the best fit for your child.',
      color: '#4CAF50',
    },
    {
      icon: Rocket,
      number: '03',
      title: 'Swipe, Practice, Repeat',
      description: 'Children learn through short swipe-based sessions, earn rewards, and revisit words through smart repetition.',
      color: '#2196F3',
    },
  ];

  return (
    <section id="how-it-works" className="py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-left sm:text-center mb-8 sm:mb-16 space-y-4">
          <div className="inline-block px-4 py-2 bg-[#FFF3E0] rounded-full border border-[#FFE0B2]">
            <span className="text-[#FF7F30] font-semibold text-sm tracking-wide">How It Works</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#333333] leading-[1.05] sm:leading-tight lg:leading-[1.1]">
            Get Started in
            <span className="block text-[#FF7F30]">Three Simple Steps</span>
          </h2>
          <p className="text-lg sm:text-xl text-[#666666] max-w-2xl mx-auto leading-relaxed">
            Set up a learner, choose the right language and voice, and turn daily practice into a playful routine that builds real vocabulary.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-12 relative">
          {/* Connecting line - desktop only */}
          <div className="hidden md:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-[#FF7F30] via-[#4CAF50] to-[#2196F3] opacity-20 -z-10"></div>

          {steps.map((step, index) => (
            <div key={index} className="relative text-left sm:text-center space-y-6">
              {/* Icon container */}
              <div className="relative inline-block">
                <div
                  className="w-32 h-32 rounded-3xl flex items-center justify-center mx-0 sm:mx-auto"
                  style={{ backgroundColor: `${step.color}20` }}
                >
                  <step.icon size={48} style={{ color: step.color }} />
                </div>
                {/* Step number badge */}
                <div
                  className="absolute -top-2 -right-2 w-12 h-12 rounded-full flex items-center justify-center font-bold text-white text-lg"
                  style={{ backgroundColor: step.color }}
                >
                  {step.number}
                </div>
              </div>

              <div className="space-y-3">
                <h3 className="text-2xl font-bold text-[#333333]">{step.title}</h3>
                <p className="text-[#666666] leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;